import { gql } from "@apollo/client";

export const AssetCustomer = gql`
    query AssetCustomer ($id: ID!) {
        assetLocation (id: $id) {
            id
            owner {
                id
                name
                region {
                    id
                    key
                }
                address {
                    id
                    title
                    postalCode
                    city
                    timezone {
                        key
                        label
                    }
                    country {
                        name
                        countryCode
                    }
                }
            }
        }
    }
`;
